import React, { useState } from "react";
import { ModalTask } from "./ModalTask";

export const BtnSua = ({ item, onReload, disabled }) => {
    const [show, setShow] = useState(false);
    return (
        <>
            <a type="button" className="popover-basic"  disabled={disabled} onClick={() => setShow(true)} title="Sửa">
                <img src="/app-assets/images/icon-edit-v2.png" alt="Sửa" />
            </a>
            {show && <ModalTask mode="update" item={item} show={show} onHide={() => setShow(false)} onSaved={() => { setShow(false); onReload(); }} />}
        </>
    );
};